export const aud = (n) =>
  new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: Number.isInteger(Number(n)) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(Number(n))

export const productSlug = (sku) => String(sku).toLowerCase()

// "(mm)" in an option name means its values are millimetres — but only numeric values
// take the unit, so an opted-out part reads "None", not "Nonemm".
export const optionUnit = (optName, value) =>
  (/\(mm\)/.test(optName) && /\d/.test(String(value ?? '')) ? 'mm' : '')

// A dimension is one word to a reader, so "U-Clamp 25mm x 50mm" must never wrap into
// "… 25mm" / "x 50mm". Non-breaking spaces glue the measurement together and leave
// the rest of the name free to wrap wherever it likes.
const NBSP = '\u00a0'
export const tidyName = (name) =>
  String(name ?? '').replace(
    /(\d+(?:\.\d+)?\s*mm)\s*([x\u00d7])\s*(\d+(?:\.\d+)?\s*mm)/gi,
    (_, a, x, b) => `${a}${NBSP}${x}${NBSP}${b}`,
  )

export function fromPrice(product) {
  if (product.min_price != null) return { min: product.min_price, sale: product.min_sale_price }
  return { min: product.price, sale: product.sale_price }
}
